import { IAuthFromGeneric } from "components/templates/Auth-from-generic/models/Auth-from-generic.interface";

export const newPasswordHeaderInformation: IAuthFromGeneric['headerInformation'] = {
  title: '¡Todo listo!',
  text: 'Ingresa tu nueva contraseña',
};